import {
  ISearchParams,
  SortByEnum,
  SortOrderEnum,
} from '../entity-data/entity-data.data';

export const UNBILLED_SEARCH_PARAMS_KEY = 'unbilled_tracked_list_search_params';
export const BILLED_SEARCH_PARAMS_KEY = 'billed_tracked_list_search_params';
export const ALL_YEARS = -1;

export const DEFAULT_SEARCH_PARAMS: ISearchParams = Object.freeze({
  sort_by: SortByEnum.start_date,
  sort_order: SortOrderEnum.desc,
  year: ALL_YEARS,
});

export enum TrackedTimeFiltersEnum {
  unbilled = 'unbilled',
  billed = 'billed',
}
